import { useCallback } from 'react';
import {
    EnterpriseParameters,
    CheckInConfigurationResult,
    CheckInConfigurationUpdateParameters,
} from '@mews-commander/data-access';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { useAPI } from '@mews/framework';
import { createFetchAction, useCommanderThunkDispatch } from '@mews-commander/utils';
import prefix from '@mews-commander/legacy-entities/src/prefix';

const CHECK_IN_CONFIGURATIONS_GET_ALL_FETCH = prefix('CHECK_IN_CONFIGURATIONS_GET_ALL_FETCH');
type FetchCheckInConfigurationsParams = Pick<EnterpriseParameters, 'enterpriseId'>;

const fetchCheckInConfigurations =
    (params: FetchCheckInConfigurationsParams): CommanderThunkAction<AsyncAction<CheckInConfigurationResult>> =>
    async (dispatch, _getState, { repositories }) =>
        dispatch(
            createFetchAction(CHECK_IN_CONFIGURATIONS_GET_ALL_FETCH, repositories.checkInConfigurations.getAll(params))
        );

export const useCheckInConfigurations = ({ enterpriseId }: FetchCheckInConfigurationsParams) => {
    const dispatch = useCommanderThunkDispatch();
    const fetchData = useCallback(
        async () => dispatch(fetchCheckInConfigurations({ enterpriseId })),
        [dispatch, enterpriseId]
    );
    return useAPI(fetchData, undefined);
};

const CHECK_IN_CONFIGURATIONS_UPDATE_FETCH = prefix('CHECK_IN_CONFIGURATIONS_UPDATE_FETCH');
type UpdateCheckInConfigurationsParams = Pick<CheckInConfigurationUpdateParameters, 'enterpriseId' | 'updates'>;

export const updateCheckInConfigurations =
    (params: UpdateCheckInConfigurationsParams): CommanderThunkAction<AsyncAction<CheckInConfigurationResult>> =>
    async (dispatch, _getState, { repositories }) =>
        dispatch(
            createFetchAction(CHECK_IN_CONFIGURATIONS_UPDATE_FETCH, repositories.checkInConfigurations.update(params))
        );
